import type {
    PaymentPubSubEvent} from "./payments/payment-pubsub-event";
import {
    paymentPubSubEventTypes,
} from "./payments/payment-pubsub-event";

type PubSubEvent = PaymentPubSubEvent;
type PubSubEventType = PubSubEvent["type"];
const pubsubEventTypes: PubSubEventType[] = [...paymentPubSubEventTypes];

export type { PubSubEvent, PubSubEventType };
export { pubsubEventTypes };
